"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSetupsDTO = exports.SetupsDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.SetupsDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    defaultProperties: [],
    definitions: {
        SetupItemDTO: {
            defaultProperties: [],
            properties: {
                key: {
                    type: "string",
                },
                tracker: {
                    $ref: "#/definitions/TrackerDTO",
                },
                value: {},
            },
            required: ["key", "value"],
            type: "object",
        },
        TrackerDTO: {
            defaultProperties: [],
            properties: {
                comment: {},
                createdApp: {
                    $ref: "#/definitions/appType",
                },
                createdAt: {
                    type: "number",
                },
                createdBy: {
                    type: "string",
                },
                key: {
                    type: "string",
                },
                previousValue: {},
                updatedApp: {
                    $ref: "#/definitions/appType",
                },
                updatedAt: {
                    type: "number",
                },
                updatedBy: {
                    type: "string",
                },
            },
            required: ["createdApp", "createdAt", "createdBy", "updatedApp", "updatedAt", "updatedBy"],
            type: "object",
        },
        appType: {
            enum: ["A", "GA", "I", "M", "SC", "SE", "T", "U", "W"],
            type: "string",
        },
        setupTarget: {
            enum: ["ACCOUNT", "ORG", "UNIT", "USER"],
            type: "string",
        },
    },
    properties: {
        data: {
            additionalProperties: {
                $ref: "#/definitions/SetupItemDTO",
            },
            defaultProperties: [],
            type: "object",
        },
        type: {
            $ref: "#/definitions/setupTarget",
        },
    },
    required: ["data", "type"],
    type: "object",
};
exports.isSetupsDTO = exports.ajv.compile(exports.SetupsDTOSchema);
function validate(value) {
    if (exports.isSetupsDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isSetupsDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "SetupsDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=Setups.validator.js.map